import { ReactNode } from "react";
import { StepType } from '@reactour/tour';
import { Header } from "semantic-ui-react";

type TourMap = { [k: string]: { steps: StepType[], startTour: ReactNode } }

export const tours: TourMap = {
  dashboard: {
    startTour: <><Header>Take a tour </Header><p>Hi There, do you want to take a quick tour?</p></>,
    steps: [
      {
        selector: '[data-tour="nav-root-shipment"]',
        content: () => (<>
          All shipments can be found here. <br />
          <i>If your account allows for project shipments or warehouse picking, that will appear here.</i>
        </>),
        position: "right"
      },
      {
        selector: '[data-tour="nav-root-partner"]',
        content: () => (<>
          All Your partner information here. <br />
          You can invite partners (shippers, carriers, consignees) onto the platform here.
        </>),
        position: "right"
      },
      {
        selector: '[data-tour="nav-root-location"]', content: () => (<>
          All your addresses can be found back in your address book here.
        </>),
        position: "right"
      },
      {
        selector: '[data-tour="nav-root-reporting"]', content: () => (<>
          You can consult embedded reports here.
        </>),
        position: "top"
      },
      {
        selector: '[data-tour="header-search-input"]',
        content: () => (<>
          Search here for anything: shipments, partners, projects, and more!
        </>),
        position: "bottom"
      }
    ]
  },
  shipment: {
    startTour: <><Header>Take a tour </Header><p>Hi There, do you want to take a quick tour and discover the shipment page?</p></>,
    steps: [
      {
        selector: "main.shipment",
        content: () => <>
          This page holds all the information about the shipment and, depending on what the status is, fields become visible to partners.
        </>
      },
      {
        selector: '[data-tour="shipment-in-page-nav"]', content: () => (<>
          Quickly navigate in the page using the navigation pane.
        </>)
      },
      {
        selector: '[data-tour="shipment-stages-section"]', content: () => (<>
          All shipments can have one or more stages. The stage is equal to a shipping leg.
        </>)
      },
      {
        selector: '[data-tour="shipment-stage-split"]', content: () => (<>
          You can split stages by adding a stop-in-between.
        </>)
      },
      {
        selector: '[data-tour="shipment-stage-release"]', content: () => (<>
          When you have assigned a carrier, you can release the stage to the partner. Only then it will be visible for the other party.
        </>)
      },
      {
        selector: '[data-tour="shipment-item-section"]', content: () => (<>
          Add shipping items here, you can drag and drop items to create a hierarchy.
        </>)
      },
      {
        selector: '[data-tour="shipment-costs-section"]', content: () => (<>
          Allocate a carrier here. Either select a carrier from the list, either start a new spot rate request for this shipment or manually select a partner to proceed with shipping.
        </>)
      },
      {
        selector: '[data-tour="shipment-conversation-btn"]', content: () => (<>
          Discuss topics on the shipment with partners and collaborate in the cloud.
        </>)
      },
    ]
  }
}